/**
 * Strips HTML tags from a string and decodes HTML entities
 * Server-side safe implementation
 */
export function stripHtmlTags(htmlString: string): string {
  if (!htmlString) return "";
  
  // HTML entity mapping for common entities
  const htmlEntities = {
    '&nbsp;': ' ',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&auml;': 'ä',
    '&ouml;': 'ö',
    '&aring;': 'å',
    '&Auml;': 'Ä',
    '&Ouml;': 'Ö',
    '&Aring;': 'Å',
    '&ndash;': '–',
    '&mdash;': '—',
    '&hellip;': '…',
    '&bull;': '•',
    '&copy;': '©',
    '&reg;': '®',
    '&trade;': '™',
    '&euro;': '€',
    '&pound;': '£',
    '&yen;': '¥',
    '&cent;': '¢',
    '&sect;': '§',
    '&deg;': '°',
    '&apos;': "'",
    '&raquo;': '»',
    '&laquo;': '«',
    '&rsquo;': "'",
    '&lsquo;': "'",
    '&ldquo;': '"',
    '&rdquo;': '"',
    '&lsaquo;': '«',
    '&rsaquo;': '»',
  };
  
  // First remove HTML tags
  let text = htmlString.replace(/<[^>]*>/g, '');
  
  // Replace common HTML entities
  Object.entries(htmlEntities).forEach(([entity, replacement]) => {
    text = text.replace(new RegExp(entity, 'g'), replacement);
  });
  
  return text.trim();
}

/**
 * Extracts a title from HTML content, typically from the first heading
 */
export function extractTitleFromContent(content: string): string {
  if (!content) return "";
  
  // Try to extract a title from first heading if available
  const titleMatch = content.match(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/i);
  if (titleMatch && titleMatch[1]) {
    return stripHtmlTags(titleMatch[1]);
  }
  
  return "";
} 